import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ql-formats" }
const _hoisted_2 = { class: "text--mini text--darker" }

import { withDefaults, computed, ComputedRef, WritableComputedRef } from "vue"

/* ------------------- Props ----------------- */

interface PropsInterface {
	propModel: string;
	readonly?: boolean;
	/**
	 * Will also display instead of toolbar when readonly is set to true.
	 */
	placeholderText?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'QuillEditor',
  props: {
    propModel: { default: "" },
    readonly: { type: Boolean, default: false },
    placeholderText: { default: "" }
  },
  emits: ["changed"],
  setup(__props: any, { emit }: { emit: ({
	(event: "changed", value: string): string,
}), expose: any, slots: any, attrs: any }) {

const props = __props as { propModel: string, readonly: boolean, placeholderText: string };





/* ------------------- Properties ----------------- */

const isReadonly: ComputedRef<boolean> = computed(() => props.readonly)
const innerModel: WritableComputedRef<string> = computed({
	get() {
		return props.propModel
	},
	set(value: string) {
		emit("changed", value)
	}
})


return (_ctx: any,_cache: any) => {
  const _component_p_editor = _resolveComponent("p-editor")!

  return (_openBlock(), _createBlock(_component_p_editor, {
    modelValue: _unref(innerModel),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(innerModel) ? (innerModel).value = $event : null)),
    editorStyle: "height: 320px",
    readonly: _unref(isReadonly),
    placeholder: `${__props.placeholderText}...`
  }, _createSlots({ _: 2 }, [
    (_unref(isReadonly))
      ? {
          name: "toolbar",
          fn: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
              _createElementVNode("p", _hoisted_2, _toDisplayString(__props.placeholderText), 1)
            ])
          ]),
          key: "0"
        }
      : {
          name: "toolbar",
          fn: _withCtx(() => [
            _createElementVNode("span", { class: "ql-formats" }, [
              _createElementVNode("select", { class: "ql-header" })
            ]),
            _createElementVNode("span", { class: "ql-formats" }, [
              _createElementVNode("button", { class: "ql-bold" }),
              _createElementVNode("button", { class: "ql-italic" }),
              _createElementVNode("button", { class: "ql-underline" }),
              _createElementVNode("button", { class: "ql-strike" })
            ]),
            _createElementVNode("span", { class: "ql-formats" }, [
              _createElementVNode("select", { class: "ql-color ql-picker ql-color-picker" }),
              _createElementVNode("button", {
                class: "ql-script",
                value: "sub"
              }),
              _createElementVNode("button", {
                class: "ql-script",
                value: "super"
              })
            ]),
            _createElementVNode("span", { class: "ql-formats" }, [
              _createElementVNode("button", {
                class: "ql-list",
                value: "ordered"
              }),
              _createElementVNode("button", {
                class: "ql-list",
                value: "bullet"
              }),
              _createElementVNode("button", {
                class: "ql-indent",
                value: "-1"
              }),
              _createElementVNode("button", {
                class: "ql-indent",
                value: "+1"
              }),
              _createElementVNode("select", { class: "ql-align ql-picker ql-icon-picker" })
            ]),
            _createElementVNode("span", { class: "ql-formats" }, [
              _createElementVNode("button", { class: "ql-link" })
            ]),
            _createElementVNode("span", { class: "ql-formats" }, [
              _createElementVNode("button", { class: "ql-clean" })
            ])
          ]),
          key: "1"
        }
  ]), 1032, ["modelValue", "readonly", "placeholder"]))
}
}

})